import { buyerFees } from '../CommonComponent/staticValues';

const LEGACY_NO_FEES_VALUE = 'no additional fees';

export const isBuyerFeeType = (value, type) => {
    if (!value) return false;
    const lower = value.toLowerCase();
    if (type === 'no_fees' && lower === LEGACY_NO_FEES_VALUE) return true;
    return lower.includes(type);
}

export const buyerFeeLabel = (key) => {
    if (!key) return key;
    if (!buyerFees) return key;
    if (key.toLowerCase() === LEGACY_NO_FEES_VALUE) return buyerFees.find(f => f.key === 'no_fees')?.name ?? key;
    return buyerFees.find(f => f.key === key)?.name ?? key;
}
